module.exports = __webpack_public_path__ + "img/not-authorized.1ab15c5e.svg";